import { Modifier, Entity, EditorState } from 'draft-js'
import { Record } from 'immutable'
import { createPlugin, pluginUtils } from 'draft-extend'
import { connect } from 'react-redux'
import IconSVG from 'svg-inline-react'
import { bindActionCreators } from 'redux'
import { renderNothing, branch, withProps, withHandlers, compose, lifecycle, withState } from 'recompose'
import Fuse from 'fuse.js'
import TetherComponent from 'react-tether'
import cx from 'classnames'
import onClickOutside from 'react-onclickoutside-decorator'

import Tag from 'shared-web/src/components/Tag'

import { makeHasGate } from 'app/modules/gates/selectors'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import ConditionalRender from 'components/shared/ConditionalRender'
import clearbitProperties from 'constants/ClearbitProperties'
import demandbaseProperties from 'constants/DemandbaseProperties'
import { properties } from 'app/modules/endUser/attribute/selectors'
import { fetchAttributes } from 'app/modules/endUser/attribute/actions'
import { Property } from 'app/modules/endUser/attribute/models'

import { isConnectedTo } from 'app/modules/integrations/selectors'

import socialSplashSrc from '!svg-inline?removeTags=true!images/svg/social-splash.svg'

import './style.styl'

const TokenPopoverSteps = {
  SELECT: 'select',
  CONFIRM: 'confirm',
}

export const PropertyNamespaces = {
  USER: 'user',
  CLEARBIT: 'clearbit',
  ACCOUNT: 'account',
  DEMANDBASE: 'demandbase'
}

/* TODO: remove this code once account attributes are pulled in from Account API */
const ExtraProperty = Record({
  name: null,
  displayName: null,
  displayNamespace: PropertyNamespaces.USER,
  requiresABM: false,
})

const extraProperties = [
  new ExtraProperty({ 'name': 'account.name', 'displayName': 'Account Name', 'displayNamespace': PropertyNamespaces.USER, requiresABM: true }),
]
/* END TODO */

const tokenStringFromProperty = (property, namespace) => {
  let tokenString = ''
  if (!property.displayNamespace) {
    tokenString = `${namespace}.`
  }
  return `${tokenString}${property.get('name')}`
}

const insertToken = (property, editorState, pushChange = () => {}) => {
  const contentState = Modifier.insertText(
    editorState.getCurrentContent(),
    editorState.getSelection(),
    property,
    null,
    Entity.create(ENTITY_TYPE, 'IMMUTABLE', {
      value: property,
    })
  )
  pushChange(EditorState.push(editorState, contentState, 'insert-characters'))
}

const TokenPopoverSelect = ({
  userProperties,
  clearbitProperties,
  search,
  onSearchChange,
  onPropertySelect,
  selectedTab,
  onClearbitTabClick,
  onUserTabClick,
  noPropertiesShown,
  hideClearbitTab,
  hasClearbitEnabled,
  onDemandbaseTabClick,
  hasDemandbase
}) => (
  <div className="popover-selector-container">
    <div className="popover-selector-section popover-selector-section-top drift-form">
      <input
        className="popover-selector-search-input"
        type="text"
        value={search}
        onChange={onSearchChange}
        placeholder="Search"
      />
    </div>
    {hasDemandbase &&
      <div className="rich-editor-token-popover-selector-tab-container">
        <span className={cx('rich-editor-token-popover-selector-tab-option', { active : selectedTab === PropertyNamespaces.USER })} onClick={onUserTabClick}>User</span>
        <span className={cx('rich-editor-token-popover-selector-tab-option', { active : selectedTab === PropertyNamespaces.DEMANDBASE })} onClick={onDemandbaseTabClick}>Demandbase</span>
      </div>
    }
    {!hideClearbitTab && hasClearbitEnabled && !hasDemandbase &&
      <div className="rich-editor-token-popover-selector-tab-container">
        <span className={cx('rich-editor-token-popover-selector-tab-option', { active : selectedTab === PropertyNamespaces.USER })} onClick={onUserTabClick}>User</span>
        <span className={cx('rich-editor-token-popover-selector-tab-option', { active : selectedTab === PropertyNamespaces.CLEARBIT })} onClick={onClearbitTabClick}>Clearbit</span>
      </div>
    }
    <div className="rich-editor-token-popover-options">
      {selectedTab === PropertyNamespaces.USER &&
       userProperties.map(({ displayName, name, namespaceOverride }) => (
        <div key={name} className="rich-editor-token-popover-option" onClick={() => onPropertySelect(name, namespaceOverride || PropertyNamespaces.USER)}>
          <Tag className="rich-editor-token" tag={{ name }} />
          <span className="rich-editor-token-popover-option-name">{displayName}</span>
        </div>
      ))}
      {selectedTab === PropertyNamespaces.CLEARBIT &&
       clearbitProperties.map(({ displayName, name }) => (
        <div key={name} className="rich-editor-token-popover-option" onClick={() => onPropertySelect(name, PropertyNamespaces.CLEARBIT)}>
          <Tag className="rich-editor-token" tag={{ name }} />
          <span className="rich-editor-token-popover-option-name">{displayName}</span>
        </div>
      ))}
      {selectedTab == PropertyNamespaces.DEMANDBASE &&
        demandbaseProperties.map(({ displayName, name}) => (
          <div key={name} className="rich-editor-token-popover-option" onClick={() => onPropertySelect(name, PropertyNamespaces.DEMANDBASE)}>
            <Tag className="rich-editor-token" tag={{ name }} />
            <span className="rich-editor-token-popover-option-name">{displayName}</span>
          </div>
      ))}
      <ConditionalRender className="popover-selector-empty-options" condition={noPropertiesShown}>
        <IconSVG src={socialSplashSrc} />
        <p>There are no personalization attributes matching your search.</p>
      </ConditionalRender>
    </div>
  </div>
)

const TokenPopoverConfirm = ({ onDefaultCancel, onDefaultConfirm, selectedProperty, onDefaultChange }) => (
  <div className="popover-selector-container">
    <div className="popover-selector-section popover-selector-section-top">
      <div className="popover-selector-property-preview">{selectedProperty.name}</div>
      <div onClick={onDefaultCancel} className="link">
        Edit
      </div>
    </div>
    <div className="drift-form popover-token-confirm-form">
      <label className="default-form-label">Default Value:</label>
      <input type="text" placeholder="enter default..." onChange={onDefaultChange} />
      <p className="default-form-extra-details">
        Default values display when a contact doesn‘t have a value for this variable
      </p>
    </div>

    <div className="popover-selector-section">
      <div onClick={onDefaultCancel} className="popover-selector-section-button drift-button drift-button-secondary">
        Cancel
      </div>
      <div onClick={onDefaultConfirm} className="popover-selector-section-button drift-button drift-button-primary">
        Insert
      </div>
    </div>
  </div>
)

const TokenPopover = props => (
  <div
    className={cx('rich-editor-token-popover', { 'rich-editor-popover-bottom-anchor': !!props.popoverAnchorBottom })}
  >
    {props.popoverStep === TokenPopoverSteps.SELECT && <TokenPopoverSelect {...props} />}
    {props.popoverStep === TokenPopoverSteps.CONFIRM && <TokenPopoverConfirm {...props} />}
  </div>
)

const TokenButton = props => (
  <TetherComponent
    attachment="top left"
    targetAttachment="top right"
    targetOffset="0 10px"
    constraints={[{ to: 'scrollParent', attachment: 'together' }]}
  >
    <div className="rich-editor-token-button-container">
      <div
        className={cx('rich-editor-token-button', 'rich-editor-toolbar-button', { active: props.popoverOpen })}
        onClick={props.togglePopoverOpen}
      >
        Personalization
      </div>
      {props.popoverOpen && <TokenPopover {...props} />}
    </div>
  </TetherComponent>
)

const mapStateToProps = state => ({
  userProperties: properties(state).toArray(),
  hideClearbitTab: PlaybookSelectors.getIsEmailPlaybook(state),
  hasClearbitEnabled: PlaybookSelectors.hasEnterpriseActions(state),
  hasDemandbase: isConnectedTo(state, 'demandbase'),
  hasABM: makeHasGate('ABM')(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAttributes,
    },
    dispatch
  ),
})

export const TokenButtonContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      this.props.actions.fetchAttributes()
    },
  }),
  withState('selectedProperty', 'setSelectedProperty', undefined),
  withState('selectedNamespace', 'setSelectedNamespace', undefined),
  withState('selectedTab', 'setSelectedTab', PropertyNamespaces.USER),
  withState('popoverStep', 'setPopoverStep', TokenPopoverSteps.SELECT),
  withState('popoverOpen', 'setPopoverOpen', false),
  withState('search', 'setSearch', ''),
  withState('defaultValue', 'setDefaultValue', undefined),
  withHandlers({
    onPropertySelect: props => (name, namespace) => {
      let selectedProperty = extraProperties.filter(prop => prop.displayNamespace === PropertyNamespaces.USER).filter(prop => !prop.requiresABM || props.hasABM).concat(props.userProperties).find(property => property.get('name') === name)
      if (namespace === PropertyNamespaces.CLEARBIT) {
        selectedProperty = new Property(clearbitProperties.find(property => property.name === name))
      }
      if (namespace === PropertyNamespaces.DEMANDBASE) {
        selectedProperty = new Property(demandbaseProperties.find(property => property.name === name))
      }
      props.setSelectedNamespace(namespace)
      props.setSelectedProperty(selectedProperty)
      props.setPopoverStep(TokenPopoverSteps.CONFIRM)
    },
    onDefaultConfirm: props => () => {
      props.setPopoverStep(TokenPopoverSteps.SELECT)
      const defaultValue = props.defaultValue ? ` or "${props.defaultValue}"` : ''
      const insertVal = `{{ ${tokenStringFromProperty(props.selectedProperty, props.selectedNamespace)}${defaultValue} }}`
      insertToken(insertVal, props.editorState, props.onChange)
      props.setPopoverOpen(false)
    },
    onClearbitTabClick: props => () => {
      props.hasClearbitEnabled && props.setSelectedTab(PropertyNamespaces.CLEARBIT)
    },
    onDemandbaseTabClick: props => () => {
      props.hasDemandbase && props.setSelectedTab(PropertyNamespaces.DEMANDBASE)
    },
    onUserTabClick: props => () => {
      props.setSelectedTab(PropertyNamespaces.USER)
    },
    onDefaultCancel: props => () => {
      props.setSelectedNamespace(undefined)
      props.setSelectedProperty(undefined)
      props.setDefaultValue(undefined)
      props.setPopoverStep(TokenPopoverSteps.SELECT)
    },
    togglePopoverOpen: props => () => {
      props.setPopoverOpen(!props.popoverOpen)
    },
    onSearchChange: props => event => {
      props.setSearch(event.target.value)
    },
    onDefaultChange: props => event => {
      // make sure to escape double quotes
      props.setDefaultValue(event.target.value.replace('"', '\\"'))
    },
    onClickOutside: props => () => {
      props.setPopoverOpen(false)
    },
  }),
  withProps(props => {
    const userProperties = extraProperties.filter(prop => prop.displayNamespace === PropertyNamespaces.USER).filter(prop => !prop.requiresABM || props.hasABM).concat(props.userProperties)
    if (!props.search) {
      return {
        clearbitProperties,
        userProperties,
        demandbaseProperties
      }
    } else {
      const fuseConfig = { keys: ['displayName', 'name']}
      const userFuse = new Fuse(userProperties, fuseConfig)
      const clearbitFuse = new Fuse(clearbitProperties, fuseConfig)
      const demandbaseFuse = new Fuse(demandbaseProperties, fuseConfig)
      return {
        userProperties: userFuse.search(props.search),
        clearbitProperties: clearbitFuse.search(props.search),
        demandbaseProperties: demandbaseFuse.search(props.search)
      }
    }
  }),
  withProps(props => ({
    noPropertiesShown: (props.selectedTab === PropertyNamespaces.USER && props.userProperties.length === 0)
      || (props.selectedTab === PropertyNamespaces.CLEARBIT && props.clearbitProperties.length === 0
      || (props.selectedTab === PropertyNamespaces.DEMANDBASE && props.demandbaseProperties.length === 0))
  })),
  branch(({ noPersonalization }) => noPersonalization, renderNothing),
  onClickOutside
)(TokenButton)

const ENTITY_TYPE = 'token'

const TokenDecorator = {
  strategy: pluginUtils.entityStrategy(ENTITY_TYPE),
  component: props => <Tag className="rich-editor-token" tag={{ name: props.children }} />,
}

const entityToHTML = (entity, originalText) => {
  if (entity.type === ENTITY_TYPE) {
    return entity.data.value
  }
  return originalText
}

const textToEntity = text => {
  const results = []
  const pattern = /\{\{[\s\w\.\'\"\\\|\(\)]+\}\}/g
  text.replace(pattern, (match, offset) => {
    results.push({
      offset,
      length: match.length,
      entity: Entity.create(ENTITY_TYPE, 'IMMUTABLE', { value: match }),
      result: match,
    })
  })
  return results
}

export default createPlugin({
  decorators: TokenDecorator,
  buttons: TokenButtonContainer,
  textToEntity,
  entityToHTML,
})



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Editor/plugins/token/index.js